import { Box, LinearProgress, Stack, Typography } from "../../components";

export const ProgressBar = (props: { value: number; text?: string }) => {
  return (
    <Stack direction="row" alignItems="center">
      <Box sx={{ flex: 1, position: "relative" }}>
        <LinearProgress variant="determinate" value={props.value} sx={{ height: "20px" }} color="primary" />
        <Typography
          variant="body2"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
          }}
        >
          {props.text ? props.text + " " : ""}
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Stack>
  );
};
